// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.header.FindTodaysPatientsAppointmentsForProviderRequest */
/* istanbul ignore next */
@GandalfModel
export class FindTodaysPatientsAppointmentsForProviderRequest extends GandalfModelBase {

	@GandalfLabel('Location')
	@GandalfProperty({ designType: Number })
	locationId!: number;

	@GandalfLabel('Provider')
	@GandalfValidator({ notNull: { message: 'Provider is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	providerId!: number;

}
